import React, { Component } from "react";
import PropTypes from "prop-types";
import {
	EmailShareButton,
	FacebookShareButton,
	LinkedinShareButton,
	TwitterShareButton
} from "react-share";
import { extractNameFromPageTitle } from "components/utility/analytics/util";

class ContentPageSharePublicLinksSocial extends Component {
	getSocialLinks = (link, quoteText, index) => {
		const { shareUrl, analytics = {} } = this.props;
		let socialLinks = [];
		let linkLabel = link.label.toLowerCase();

		const gaAnalyticsFor = (channel) => ({
			"data-a-evt": "Share",
			"data-a-icon": channel,
			"data-a-name": extractNameFromPageTitle(analytics.title),
			"data-a-comp": analytics.comp
		});

		if (linkLabel === "facebook") {
			if (quoteText) {
				socialLinks.push(
					<FacebookShareButton
						url={shareUrl}
						resetButtonStyle={false}
						key={index}
						quote={quoteText}
						{...gaAnalyticsFor("facebook")}
					>
						<div className="icon-facebook" aria-label={link.label + " icon"}></div>
					</FacebookShareButton>
				);
			} else {
				socialLinks.push(
					<FacebookShareButton
						url={shareUrl}
						resetButtonStyle={false}
						key={index}
						{...gaAnalyticsFor("facebook")}
					>
						<img src={link.imageUrl} alt={link.label} aria-label={link.label + " icon"} />
						<div className="content-page-share-public-links-social-title">{link.label}</div>
					</FacebookShareButton>
				);
			}
		} else if (linkLabel === "x") {
			if (quoteText) {
				socialLinks.push(
					<TwitterShareButton
						url={shareUrl}
						resetButtonStyle={false}
						key={index}
						title={quoteText}
						{...gaAnalyticsFor("twitter")}
					>
						<div className="icon-twitter" aria-label={link.label + " icon"}></div>
					</TwitterShareButton>
				);
			} else {
				socialLinks.push(
					<TwitterShareButton
						url={shareUrl}
						resetButtonStyle={false}
						key={index}
						{...gaAnalyticsFor("twitter")}
					>
						<img src={link.imageUrl} alt={link.label} aria-label={link.label + " icon"} />
						<div className="content-page-share-public-links-social-title">{link.label}</div>
					</TwitterShareButton>
				);
			}
		}
		if (linkLabel === "linkedin") {
			if (quoteText) {
				socialLinks.push(
					<LinkedinShareButton
						url={shareUrl}
						resetButtonStyle={false}
						key={index}
						{...gaAnalyticsFor("linkedin")}
					>
						<div className="icon-linkedin" aria-label={link.label + " icon"}></div>
					</LinkedinShareButton>
				);
			} else {
				socialLinks.push(
					<LinkedinShareButton
						url={shareUrl}
						resetButtonStyle={false}
						key={index}
						{...gaAnalyticsFor("linkedin")}
					>
						<img src={link.imageUrl} alt={link.label} aria-label={link.label + " icon"} />
						<div className="content-page-share-public-links-social-title">{link.label}</div>
					</LinkedinShareButton>
				);
			}
		}
		if (linkLabel === "email") {
			let pageTitle = document.querySelector('meta[name="description"]')
				? document.querySelector('meta[name="description"]').content
				: "";
			socialLinks.push(
				<EmailShareButton
					url={shareUrl}
					resetButtonStyle={false}
					subject={pageTitle}
					key={index}
					{...gaAnalyticsFor("email")}
				>
					<img src={link.imageUrl} alt={link.label} aria-label={link.label + " icon"} />
					<div className="content-page-share-public-links-social-title">{link.label}</div>
				</EmailShareButton>
			);
		}
		return socialLinks;
	};

	render() {
		const { analytics, data, quoteText } = this.props;
		return data ? (
			<div className="content-page-share-public-links-social">
				{data.map((link, index) => {
					return (
						<div
							className="content-page-share-public-links-social-item"
							key={index}
							data-a="true"
							data-a-lbl={link.label}
							data-a-cat={analytics.category} //FIXME: make sure analytics are still working on share modal button
							data-a-act={analytics.action}
						>
							{this.getSocialLinks(link, quoteText, index)}
						</div>
					);
				})}
			</div>
		) : (
			""
		);
	}
	static propTypes = {
		analytics: PropTypes.shape({
			action: PropTypes.string,
			category: PropTypes.string,
			guid: PropTypes.string
		}),
		shareUrl: PropTypes.string,
		quoteText: PropTypes.string,
		data: PropTypes.array
	};
}

export default ContentPageSharePublicLinksSocial;
